(ns teamoesterreich.admin-mode.lebensretter.detail.jku-linz-part

  (:require [clojure.string]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            ))

(defn form [!jkuLinz jkuLinzActive]
  [mui/box
   [mui/typography {:variant "subtitle1" :style {:padding-right "3rem" :font-weight 700}} "Sonderalarmierung JKU Linz"]
   [mui/form-control-label
    {
     :style   {:background-color (if (not= jkuLinzActive @!jkuLinz) "#ffd6d2" "transparent")}
     :label   "Berechtigt"
     :control (r/as-element
                [mui/checkbox {:color    "primary"
                               :checked  (or @!jkuLinz false)
                               :onChange (fn [_ val]
                                           (reset! !jkuLinz val))
                               }])
     }
    ]
   ])

